<script setup lang="ts">
import MPropertyList from "../MPropertyList";

defineProps<{
  title?: string;
  manualWidth?: boolean;
  action?: any;
}>();
</script>
<template>
  <m-property-list v-bind="$props">
    <slot />
  </m-property-list>
</template>
